import React, { useEffect, useMemo, useState } from "react";
import Rules from "../../components/common/controls/Rules";
import MessageForm from "./msgForm";
import CustomButton from "../../components/common/controls/CustomButton";
import Loading from "../../components/Loading/Loading";
import {
  createConfigureMessage,
  updateConfigureMessage,
  getMsgConfigsDetailsService,
} from "../../services/ConfigMsgService";
import { injectIntl } from "react-intl";
import { injectIntlTranslation } from "@carrier-ecat/workflowui-globalfunctions";
import { constants } from "../../constants/constants";
import { validateRulesInput } from "../../utilities/applicationutils";

function ConfigureMsgDetails({
  modelId,
  onClose,
  onSuccess,
  msgData,
  intl,
  setSnackBar,
}) {
  const [rules, setRules] = useState([]);
  const [keepRules, setKeepRules] = useState([]);
  const [selectedCopyDrawing, setSelectedCopyDrawing] = useState("");
  const [backupRules, setBackupRules] = useState(null);
  const [copyState, setCopyState] = useState({
    origin: "",
    data: "",
  });

  const [isLoading, setIsLoading] = useState(false);

  const [messageType, setMessageType] = useState("Warning");
  const [message, setMessage] = useState("");
  const [msgName, setMsgName] = useState("");

  // Helper to generate UUID v4
  const generateUUID = () => {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        const r = (Math.random() * 16) | 0,
          v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  };

  // Main function to transform input format
  const transformDrawingRulesToDefault = (inputRuleSets) => {
    return inputRuleSets.map((ruleSet) => {
      const drawingRuleId = generateUUID();
      const drawingId = generateUUID();

      const drawingDependencies = ruleSet.rules.map((rule) => ({
        id: generateUUID(),
        dwgRuleId: drawingRuleId,
        ddName: rule.ddName,
        minValue: rule.min,
        maxValue: rule.max,
        dwgRule: null,
      }));

      return {
        drawingRuleId,
        drawingId,
        drawingDependencies,
      };
    });
  };

  const fetchDetails = async (id) => {
    await getMsgConfigsDetailsService(id)
      .then((res) => {
        const { messageName, messageType, messageContent, ruleSets } = res.data;
        setMessage(messageContent);
        setMsgName(messageName);
        setMessageType(messageType);
        const d = transformDrawingRulesToDefault(ruleSets);
        console.log(d);
        setRules(d);
        window.setRulesData(d);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (msgData && msgData?.name) {
      const { messageId = "" } = msgData;
      if (messageId) {
        setIsLoading(true);
        fetchDetails(messageId);
      }
    }
  }, [msgData]);

  const transformDrawingRules = (input) => {
    const output = {
      modelId: modelId,
      messageName: msgName,
      messageType: messageType,
      messageContent: message || "",
      ruleSets: [],
    };

    input.forEach((drawingRule, index) => {
      const rules = drawingRule.drawingDependencies.map((dep, ruleIndex) => ({
        ddName: dep.ddName,
        min: dep.minValue,
        max: dep.maxValue,
        order: ruleIndex + 1,
      }));

      output.ruleSets.push({
        order: index + 1,
        rules: rules,
      });
    });

    return output;
  };

  const SaveChanges = async (payload) => {
    if (msgData?.name) {
      payload["messageId"] = msgData?.messageId || "";
      console.log("payload: ", payload);
      await updateConfigureMessage(payload)
        .then((res) => {
          console.log(res);
          onSuccess(true);
          onClose();
        })
        .catch((err) => {
          console.log("Update config error: ", err);
          setIsLoading(false);
        });
    } else {
      await createConfigureMessage(payload)
        .then((res) => {
          console.log(res);
          onSuccess();
          onClose();
        })
        .catch((err) => {
          console.log("Create config error: ", err);
          setIsLoading(false);
        });
    }
  };

  const isEdit = useMemo(() => {
    return msgData?.messageId || "";
  }, [msgData]);

  useEffect(() => {
    window.setRulesData([]);
  }, []);

  return (
    <>
      <Loading open={isLoading} />
      <div
        style={{
          width: "1300px",
          height: "100vh",
          background: "#ffffff",
          padding: "0 20px 10px 20px",
        }}
      >
        <div style={{ borderBottom: "1px solid #c0c0c0" }}>
          <h2>
            {msgData?.name ||
              injectIntlTranslation(
                intl,
                "Create New Message",
                "Create New Message"
              )}
          </h2>
        </div>
        <div
          style={{
            display: "flex",
            height: "calc(100% - 150px)",
            margin: "20px 0",
          }}
        >
          <div
            style={{
              width: "50%",
              borderRight: "1px solid #c0c0c0",
              height: "100%",
              padding: "0 10px 0 10px",
              minWidth: "49%",
              maxWidth: "49%",
            }}
          >
            <Rules
              rules={rules}
              setIsUnsaveChanges={(data) => {
                setKeepRules(data);
              }}
              setKeepRules={setKeepRules}
              copyDrawing={selectedCopyDrawing}
              backupRules={backupRules}
              copyState={copyState}
              setCopyState={setCopyState}
              msgConfig={true}
            />
          </div>
          <div
            style={{
              width: "50%",
              height: "100%",
              padding: "0 10px 0 20px",
              marginTop: "35px",
            }}
          >
            <MessageForm
              messageType={messageType}
              setMessageType={setMessageType}
              message={message}
              setMessage={setMessage}
              msgName={msgName}
              setMsgName={setMsgName}
            />
          </div>
        </div>
        <div style={{ width: "350px", margin: "auto" }}>
          <CustomButton
            id="Save-Btn"
            name={injectIntlTranslation(
              intl,
              "saveBtnLabel",
              constants.saveBtnLabel
            )}
            color="primary"
            showGradient={true}
            fullWidth
            variant="contained"
            disabled={!msgName.trim() || !message.trim()}
            onClick={() => {
              const d = window.getRuleData();
              const temp = transformDrawingRules(d);
              const { isError = false, data = [] } = validateRulesInput(
                temp?.ruleSets
              );
              console.log("data: ", temp, data);

              if (isError === true) {
                setSnackBar(
                  true,
                  "error",
                  injectIntlTranslation(
                    intl,
                    "validationErrorRules",
                    constants.validationErrorRules
                  )
                );
              } else {
                setIsLoading(true);
                SaveChanges(temp);
              }
            }}
          >
            {injectIntlTranslation(
              intl,
              "saveBtnLabel",
              constants.saveBtnLabel
            )}
          </CustomButton>
        </div>
      </div>
    </>
  );
}

export default injectIntl(ConfigureMsgDetails);
